export default [
	{
		dataIndex: 'type',
		key: 'type',
		title: "Service",
		align: 'center',
		width: 150,
		scopedSlots: {customRender: 'service'}
	}, {
		key: 'client',
		title: 'Client',
		scopedSlots: {customRender: 'client'}
	}, {
		key: 'product',
		title: 'Product',
		scopedSlots: {customRender: 'product'}
	}
	, {
		dataIndex: 'id',
		key: 'id',
		title: 'Transaction',
		scopedSlots: {customRender: 'transaction'}
	}, {
		dataIndex: 'status',
		key: 'status',
		title: 'Status',
		scopedSlots: {customRender: 'status'}
	}, {
		dataIndex: 'elapsed',
		key: 'elapsed',
		title: 'Elapsed',
		scopedSlots: {customRender: 'elapsed'}
	}
]


